import request from '@/utils/request'

export function directionList(params) {
  return request({
    url: '/delivery_auxiliary/targeting_tags',
    method: 'get',
    params
  })
}
